/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        badge: {
            counter: {
                small: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    minWidth: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "4px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "4px",
                        type: "dimension",
                    },
                    label: {
                        fontSize: {
                            value: "0.6875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 700,
                            type: "number",
                        },
                    },
                },
                large: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                    label: {
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                    },
                },
                primary: {
                    background: {
                        value: "#d3222a",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
                secondary: {
                    background: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    borderRadius: {
                        value: "2px",
                        type: "dimension",
                    },
                },
                tertiary: {
                    background: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#d3222a",
                        type: "color",
                    },
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
